export default function getSelectedRooms() {
  return (dispatch, getState) => {
    const { selectRooms } = getState();
    return selectRooms.rooms;
  };
}
